module.exports = __webpack_public_path__ + "static/media/down_arrow_blue.bbd181c6.svg";